import React, { useState, useEffect,useRef } from "react";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useSelector, useDispatch } from "react-redux";
import { updateCampaignStatus } from "../../redux/reducers/CampaignStatusFilterSlice";
import { updateCampaignDeliveryStatus } from "../../redux/reducers/CampaignDeliveryStatusFilterSlice";
import { updateCampaignTag } from "../../redux/reducers/CampaignTagFilterSlice";
import { setMemberOnlyStatus } from "../../redux/reducers/CampaignMemberFilterSlice";
import {default as ReactSelect ,  components } from "react-select";
import { useSearchParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactMultiSelect from "../global/ReactMultiSelect";
import { useLocation, useNavigate } from 'react-router-dom';


import $ from "jquery";
import { setCampaignOwnerFilter } from "../../redux/reducers/CamapignOwnerFilterSlice";
import { setCampaignAllFilter } from "../../redux/reducers/CampaignAllSlice";
import Constants from "../../Constants";

export default function FilterCampaign({allCampaignStatus, setSearchText, searchText}) {
  const { t } = useTranslation();
  const translate = t;
  const [params ,setParams] =useSearchParams();
  const tag = params.get('tag'); 
  const navigate = useNavigate();
  const multiSelectRef = useRef(null);
 
  
  const dispatch = useDispatch();
  
  const [selectedTags, setSelectedTag] = useState([]);
  const [memberOnly, setMemberOnly] = useState(false);
  const [seletedStatus, setSelectedStatus] = useState("");
  const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState("");
  const deliveryStatus = [
    { label: "Select", value: "" },
    { label: "At Risk", value: "AT_RISK" },
    { label: "Late", value: "LATE" },
    { label: "On Track", value: "ON_TRACK" },
    // { label: "Unknown", value: "UNKNOWN" },
  ]
  const [tags, setTags] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  
  const handleInputChange = (e) => {
    if(e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  }

  const SelectTagRedux = useSelector(
    (updateCampaignTag) => updateCampaignTag.campaign_tag_filter
  ).value;
  const selectedStatusRedux = useSelector(
    (updateCampaignStatus) => updateCampaignStatus.campaign_status_filter
  ).value;
  const selectedDeliveryStatusRedux = useSelector(
    (updateCampaignDeliveryStatus) =>
      updateCampaignDeliveryStatus.campaign_delivery_status_filter
  ).value;
  const memberOnlyStatusRedux = useSelector(
    (setMemberOnlyStatus) => setMemberOnlyStatus.campaign_member_only_filter
  ).value;

  const campaignOwnerFilterRedux = useSelector(
    (campaignOwnerFilterStatus) => campaignOwnerFilterStatus.campaign_owner_filter
  ).value;

  const campaignAllFilterRedux = useSelector(
    (campaignAllFilter) => campaignAllFilter.campaign_all_filter
  ).value;


  const queryParams = new URLSearchParams(window.location.search);

   useEffect(() => {
      setSearchText(searchText);
      setSearchKey(searchText);
  },[searchText]);


  useEffect(()=>{
    if(tag !==null){
      dispatch(setMemberOnlyStatus(true));
      dispatch(setCampaignOwnerFilter(false))
      dispatch(setCampaignAllFilter(false))
    dispatch(
      updateCampaignTag([{label:tag,value:tag}])
    );
    dispatch(updateCampaignStatus(""));
    }else{
      dispatch(updateCampaignStatus(""));
      dispatch(
        updateCampaignTag([])
      );
      dispatch(setMemberOnlyStatus(false));
      dispatch(setCampaignOwnerFilter(false))
      dispatch(setCampaignAllFilter(true))
      dispatch(updateCampaignStatus(""));
      setParamsToUrl('status','All')
    }
  },[tag])

  const handleChange = (value) => {
    localStorage.setItem("globalSearch",false);
    setTimeout(function() {
      multiSelectRef.current.focus();
    }, 2000);
    dispatch(updateCampaignTag(value));
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setSearchKey(event.target.value);
    setParamsToUrl('search',event.target.value)
  };

  const handleStatusChange = (event) => {
    var selectedStatus = event.value;
    dispatch(updateCampaignStatus(selectedStatus));
    setParamsToUrl('status',selectedStatus)
  };
  const handleDeliveryStatusChange = (event) => {

    var deliveryStatus = event.value;
      dispatch(updateCampaignDeliveryStatus(deliveryStatus));
      setParamsToUrl('deliveryStatus',deliveryStatus)
  };
  
  const setParamsToUrl=(key,value)=>{
    const currentURL = window.location.href;
    // Create a URL object to work with query parameters
    const url = new URL(currentURL);
    // Remove the specific query parameter
    url.searchParams.delete('countStatus');
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(key, value);
    queryParams.set("countStatus", 'not-change');
     navigate(`?${queryParams.toString()}`);
  }

  useEffect(() => {
    var allTags =  [];
    getAxiosResponse(APIUrls.WORKSPACE_TAGS)
      .then((res) => {
        if (res.data.code === 200) {
          res.data.data.result.map((key, index) => {
            allTags.push({ label: key.display, value: key.display });
          });
          var sortedTags =  [...allTags].sort((a, b) => a.label > b.label ? 1 : -1,);
        setTags(sortedTags);
        setTags(current => [{
          label: translate("task_campaign.check_all"),
          value: "all",
        },{
          label: translate("task_campaign.uncheck_all"),
          value: "none",
        }, ...current]);
        }
      })
  }, []);
  
  useEffect(()=>{
   if(queryParams.get('deliveryStatus')===null){
    dispatch(updateCampaignDeliveryStatus(""));
   }
  },[])
  
  useEffect(()=>{
    if(queryParams.get('deliveryStatus')===null){
     dispatch(updateCampaignDeliveryStatus(""));
    }
   },[selectedDeliveryStatusRedux])
   

  useEffect(() => {
    setSelectedTag(SelectTagRedux);
    setSelectedStatus(selectedStatusRedux);
    setSelectedDeliveryStatus(selectedDeliveryStatusRedux);
    setMemberOnly(memberOnlyStatusRedux);


  }, [
    SelectTagRedux,
    selectedStatusRedux,
    selectedDeliveryStatusRedux,
    memberOnlyStatusRedux,
  ]);
  
  return (
    <div  id="filterBtn" className="filter-content flex" >
      <div className="filter-inline-list">

        <div className="department-dropdown-lg drop-down flex-center global-dropdown-block mb-0">
            <ReactSelect  
                classNamePrefix='cw'
                aria-label="Project status"
                className="global-dropdown-select"
                value={deliveryStatus.filter(function (option) {
                  return option.value === selectedDeliveryStatus;
                })}
                options={deliveryStatus}
                onChange={e => handleDeliveryStatusChange(e)}
                  />
         </div>
      </div>
      <div className="filter-inline-list">
        <div className="filter-search search activity-search">
          <input
            type="text"
            className="search-control"
            placeholder="Search.."
            value={searchKey}
            onChange={handleSearchChange}
          />
          <button type="submit" className="submit" aria-label="search">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
            >
              <path
                d="M9.43839 14.25C12.9291 14.25 15.7589 11.5637 15.7589 8.25C15.7589 4.93629 12.9291 2.25 9.43839 2.25C5.94769 2.25 3.11792 4.93629 3.11792 8.25C3.11792 11.5637 5.94769 14.25 9.43839 14.25Z"
                stroke="#88888A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.3391 15.75L13.9023 12.4875"
                stroke="#88888A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="filter-inline-list flex-center">
        <div className="drop-down flex-center global-dropdown-block global-multidropdown-check mb-0">
            <ReactMultiSelect 
              ref={multiSelectRef} 
              value={selectedTags} 
              option={tags} 
              callback={handleChange}
              ariaLabel={'Tags'}
              placeholder={'Select tags'}
              inputChange={handleInputChange}
              />
        </div>
      </div>
      <div className="filter-inline-list flex-center">
        <div className="drop-down flex-center global-dropdown-block mb-0">
            <ReactSelect  
                classNamePrefix='cw'
                aria-label="Camapign status"
                className="global-dropdown-select"
                value={allCampaignStatus.filter(function (option) {
                  return option.value === seletedStatus;
                })}
                options={allCampaignStatus}
                onChange={e => handleStatusChange(e)}
                  />
        </div>
      </div>

      <div className="filter-inline-list">
        <div className="group-btn flex-center" role="tablist">
          <button
            className={campaignAllFilterRedux ? "active dashboard-btn" : " dashboard-btn"}
            onClick={() => {
              dispatch(setMemberOnlyStatus(false));
              dispatch(setCampaignOwnerFilter(false))
              dispatch(setCampaignAllFilter(true))
              setParamsToUrl('onlyMember',false)
              setParamsToUrl('campaignOwner',false)
            }}
              role="tab"
              aria-label={campaignAllFilterRedux ? 'Current tab All' : 'All'}
              aria-selected={campaignAllFilterRedux ? "true" : "false"}
          >
            All
          </button>
          <button
            className={memberOnly ? "active member-only-btn dashboard-btn" : "member-only-btn dashboard-btn"}
            onClick={() => {
              dispatch(setMemberOnlyStatus(true));
              dispatch(setCampaignOwnerFilter(false))
              dispatch(setCampaignAllFilter(false))
              setParamsToUrl('onlyMember',true)
              setParamsToUrl('campaignOwner',false)
            }}
              role="tab"
              aria-label={memberOnly ? 'Current tab Member Only' : 'Member Only'}
              aria-selected={memberOnly ? "true" : "false"}
          >
            Member Only
          </button>
          <button
            className={campaignOwnerFilterRedux ? "active dashboard-btn  ownerFilter" : "dashboard-btn  ownerFilter"}
            onClick={() => {
              dispatch(setMemberOnlyStatus(false));
              dispatch(setCampaignOwnerFilter(true))
              dispatch(setCampaignAllFilter(false))
              setParamsToUrl('onlyMember',false)
              setParamsToUrl('campaignOwner',true)
            }}
              role="tab"
              aria-label={campaignOwnerFilterRedux ? 'Current tab Campaign Owner' : 'Campaign Owner'}
              aria-selected={campaignOwnerFilterRedux ? "true" : "false"}
          >
            Campaign Owner
          </button>
        </div>
      </div>
    </div>
  );
}
